import React from 'react';
import { Avatar } from '@mui/material';
import { getPhotoUrl } from '../../services/api';

const UserAvatar = ({ user, size = 24 }) => {
  if (!user) return null;
  
  // Obter a URL da foto com timestamp para evitar cache
  const photoUrl = user.photo ? getPhotoUrl(user.photo) : null;

  return (
    <Avatar
      src={photoUrl}
      alt={user.name}
      sx={{ 
        width: size, 
        height: size,
        fontSize: size * 0.5, // Ajusta o tamanho da letra das iniciais
        marginRight: 1 
      }}
    >
      {user.name ? user.name.charAt(0).toUpperCase() : '?'}
    </Avatar>
  );
};

export default UserAvatar;
